import React from 'react';
import $ from "jquery"

export default class Main3Component extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="main bg-light" data-nav="3">
                    <h3 id="api-api">API</h3>
                    <p>We have all the functions you can use here.</p><br/><br/>
                    <h5 id="drawer-function">drawer()</h5>
                    <p>It is used to create drawer and is the first function to be called. This function takes <span className="text-info go-options">options</span> as input.</p><br/><br/>
                    <h5 id="resizeDrawers-function">resizeDrawers()</h5>
                    <p>This function is used for the resizing event that you have to call into your resizing event. Essential for exitResizeing option.<br/>
                        </p><br/><br/>
                    <h5 id="clearDrawer-function">clearDrawer()</h5>
                    <p>It destroys the drawer.</p><br/><br/>
                    <h5 id="drawerShow-function">drawerShow()</h5>
                    <p>Displays the Drawer.</p>

                </div>
        )
    }
    

}